import React from 'react';

const LoaderSpinner = () => { 

  return (
    <div className="LoaderSpinnerDiv">
      <div className="loader">
    <div className="loader-inner ball-spin-fade-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    </div>
  </div>
  );
};

export default LoaderSpinner;